/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Features_Annotate_TitleInputs */

const en_cad_features_annotate_title = /** @type {(inputs: Cad_Features_Annotate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensions, leaders, tables and text`)
};

/**
* | output |
* | --- |
* | "Dimensions, leaders, tables and text" |
*
* @param {Cad_Features_Annotate_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_features_annotate_title = /** @type {((inputs?: Cad_Features_Annotate_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Features_Annotate_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_features_annotate_title(inputs)
});
export { cad_features_annotate_title as "cad.features.annotate_title" }